<script setup lang="ts">
import { useRouter } from 'vue-router'

interface Props {
	title?: string
	description?: string
	icon?: string
}

withDefaults(defineProps<Props>(), {
	title: 'No disponible para tu rol',
	description:
		'Tu usuario no tiene acceso a esta sección. Si crees que deberías verla, contacta al administrador de tu empresa.',
	icon: 'lock',
})

const router = useRouter()
</script>

<template>
	<div
		class="flex min-h-[60vh] flex-col items-center justify-center px-6 py-12 text-center"
		role="status"
		aria-live="polite"
	>
		<div
			class="flex h-20 w-20 items-center justify-center rounded-full bg-slate-100"
		>
			<span class="material-symbols-outlined text-[40px] text-slate-500">
				{{ icon }}
			</span>
		</div>
		<h1 class="mt-6 text-xl font-semibold text-slate-900 sm:text-2xl">
			{{ title }}
		</h1>
		<p class="mt-2 max-w-md text-sm text-slate-600 sm:text-base">
			{{ description }}
		</p>
		<div class="mt-6 flex flex-wrap items-center justify-center gap-3">
			<button
				type="button"
				class="inline-flex items-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
				@click="router.push('/dashboard')"
			>
				<span class="material-symbols-outlined text-[18px]">home</span>
				Volver al inicio
			</button>
			<button
				type="button"
				class="inline-flex items-center gap-2 rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm transition-colors hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
				@click="router.back()"
			>
				<span class="material-symbols-outlined text-[18px]">arrow_back</span>
				Regresar
			</button>
		</div>
	</div>
</template>
